/** Represents a failure to save a hirer's selected questions */
export type SaveError = {
  /** The main message describing why the save failed */
  message: string;
  /** Optional, additional information to display to the user */
  body?: string;
  /** If true, this error must be resolved by the user before they can continue */
  blocksUserFlow: boolean;
  /** Collection of HTML element ids containing errors that the hirer should be directed to view and resolve */
  errorIdentifier: string[];
};

export type DraftError = Omit<SaveError, 'blocksUserFlow'>;

interface Options {
  body?: string;
  blocksUserFlow: boolean;
  errorIdentifier: string[];
}

export const saveError =
  (message: string) =>
  ({ blocksUserFlow }: { blocksUserFlow: boolean }) =>
  (options: Partial<Omit<Options, 'blocksUserFlow'>> = {}): SaveError => ({
    errorIdentifier: [],
    ...options,
    message,
    blocksUserFlow,
  });

export const saveDraftError = (
  message: string,
  options: Omit<Options, 'blocksUserFlow'> = { errorIdentifier: [] },
): DraftError => ({
  message,
  ...options,
});
